import Chaplin from 'chaplin';
import StackTrace from 'stacktrace-js';
import ConsoleLogger from 'services/error-handler-service/logger';
import LocaleService from 'services/loader-handler-services/locale-service';

class ErrorHandler {
  constructor(errorType, code) {
    if (!ErrorHandler.instance) {
      this.type = errorType || '';
      this.code = code || '';
      this.stack = '';
      this.logLevel = 'info';

      ErrorHandler.instance = this;
    }

    return ErrorHandler.instance;
  }

  handle(error, loggerLevel = 'info') {
    this.type = error.name;
    this.logLevel = loggerLevel;
    switch (this.type) {
      case 'ClientError':
        this.clientError(error);
        break;
      case 'ServerError':
        this.serverError(error);
        break;
      case 'PropertyError':
        this.PropertyError(error);
        break;
      default:
        this.catchAll(error);
    }
  }

  clientError(error) {
    const configs = [
      'responseSetAlert.alertFailure',
      'responseSetAlert.alertFailureHeader',
      '',
      true,
      'responseSetAlert.alertFailureText',
    ];
    this.showAlert(configs);
    this.logError(error, this.logLevel);
  }

  serverError(error) {
    let text;
    const code = error.httpStatus;

    // timeout
    if (code >= 598) {
      text = LocaleService.t('Network timeout retry later');
    } else {
      text = 'responseSetAlert.alertFailureText';
    }

    const configs = ['responseSetAlert.alertFailure', 'responseSetAlert.alertFailureHeader', '', true, text];

    this.showAlert(configs);
    this.logError(error, this.logLevel);
  }

  catchAll(error) {
    this.logError(error, this.logLevel);
  }

  showAlert(config) {
    if (!config || config.length !== 5) {
      return;
    }

    const [alertType, alertTitle, icon, visibility, alertMsg] = config;
    Chaplin.mediator.publish('action:alert', alertType, alertTitle, alertMsg, icon, visibility);
  }

  logError(error, loggerLevel = 'info') {
    const errorCallback = function (err) {
      ConsoleLogger.logToConsole(err.message, loggerLevel);
    };

    StackTrace.fromError(error)
      .then(frames => {
        const errorObj = {
          error: error,
          StackFrame: frames,
        };

        //TODO: use StackTraceGPS for granular logging
        ConsoleLogger.logToConsole(errorObj, loggerLevel);
      })
      .catch(errorCallback);
  }
}

const instance = new ErrorHandler();
export default instance;
